import { CreateSupplierBody, Supplier, UpdateSupplierBody } from '@core/models/supplier.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class SupplierService {
    private readonly createSupplierURL = `/supplier/create_supplier`;
    private readonly updateSupplierURL = `/supplier/update_supplier`;
    private readonly getSuppliersURL = `/supplier/get_suppliers`;
    private readonly getSupplierByIdURL = `/supplier/get_supplier`;
    private readonly deleteSupplierURL = `/supplier/delete_supplier`;

    // ---------------------------------------------------------------

    createSupplier(body: CreateSupplierBody) {
        const formData = new FormData();
        
        Object.keys(body).forEach((key) => {
            const value = body[key as keyof CreateSupplierBody];
            if (value instanceof File) {
                formData.append(key, value);
            } else if (value !== undefined && value !== null && value !== '') {
                formData.append(key, String(value));
            }
        });

        return fetchWithRetry(
            API.post(this.createSupplierURL, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        );
    }

    updateSupplier(body: UpdateSupplierBody) {
        const formData = new FormData();
        
        Object.keys(body).forEach((key) => {
            const value = body[key as keyof UpdateSupplierBody];
            if (value instanceof File) {
                formData.append(key, value);
            } else if (value !== undefined && value !== null && value !== '') {
                formData.append(key, String(value));
            }
        });

        return fetchWithRetry(
            API.patch(this.updateSupplierURL, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        );
    }

    getSuppliers() {
        return fetchWithRetry(API.get<Supplier[]>(this.getSuppliersURL));
    }

    getSupplierById(id: number) {
        return fetchWithRetry(API.get<Supplier>(`${this.getSupplierByIdURL}/${id}`));
    }

    deleteSupplier(id: number) {
        return fetchWithRetry(API.delete(`${this.deleteSupplierURL}/${id}`));
    }
}

export default new SupplierService();

